/* eslint-disable max-len */
/**
 * Italian translations.
 */
export default {
  ACTION: {
    CANCEL: 'Cancella',
    CONFIRM: 'Conferma',
    SAVE: 'Salvar',
    SEARCH: 'Cerca'
  },
  ERROR: {},
  HEADER: {
    EMAIL: 'E-mail',
    END_DATE: 'Data di fine',
    MEMBER_ID: 'Membro ID',
    NAME: 'Nome'
  },
  LABEL: {
    ALLOW_ADD_MEMBERS: 'Permetti di aggiungere membro',
    CREATE_MEMBER: 'Aggiungi membro',
    DELETE_MEMBER_MODAL_TITLE: 'Cancella membro',
    EDIT_MEMBER: 'Modifica membro',
    EMAIL: 'E-mail',
    END_DATE: 'Data di fine',
    MEMBERS: 'Membro',
    NAME: 'Nome',
    NO: 'No',
    YES: 'Sì'
  },
  SENTENCE: {
    DELETE_MEMBER_TEXT: 'Sei sicuro di voler eliminare questo membro?',
    NO_MEMBER_NAME_EMAIL: 'Nessun nome e/o e-mail',
    NO_MEMBER_NAME_EMAIL_DETAIL: 'Inserire nome e/o e-mail',
    NO_ROWS_MEMBERS: 'Nessun membro',
    NO_ROWS_MEMBERS_DESCRIPTION: 'Modifica i criteri di ricerca'
  },
  SUCCESS: {
    MEMBER_DELETED: 'Membro eliminato con successo',
    MEMBER_DETAILS_SAVED: 'Membro aggiunto con successo',
    SUCCESS: 'Successo'
  },
  TOOLTIP: {
    EDIT_MEMBER: 'Modifica membro',
    EMAIL: 'E-mail',
    END_DATE: 'Data di fine',
    MEMBER_ID: 'Membro ID',
    NAME: 'Nome',
    REMOVE_MEMBER: 'Cancella membro'
  }
};
